import React, { createContext, useContext, useCallback } from "react"

import LanguageContext from "./LanguageContext"
import UserContext from "./UserContext"
import { formeDepuisCible, choisirTexte, FORME_VOUS } from "../utils/formeAdresse"

/* ⛔ LA FORME D'ADRESSE (« tu » ou « vous ») : UNE SEULE SOURCE, CE CONTEXTE.
   Regle et fonctions : utils/formeAdresse.js.

   Ou le contexte est pose, et nulle part ailleurs :
   - dans l'espace APPRENANT (App.js, RequireAuth : tableau de bord, Ma
     certification, module, THE SCAN), par `FormeAdresseApprenant`, d'apres la
     cible du module en cours (`actFormation.cible`) ;
   - dans le lecteur de module de l'ADMIN (FormationPlayer : apercu, plein
     ecran, essai, fin simulee), d'apres la cible du module regarde.
   Partout ailleurs (pages de connexion, espace client, ecrans de l'admin, et
   le banc du filet), la valeur par defaut s'applique : vous. Un composant
   partage avec l'admin ou l'espace client (menu, bandeau de deconnexion) y
   reste donc au vous sans rien savoir de l'espace ou il est rendu. */
const FormeAdresseContext = createContext(FORME_VOUS)

export const FormeAdresseProvider = ({ cible, children }) => (
  <FormeAdresseContext.Provider value={formeDepuisCible(cible)}>
    {children}
  </FormeAdresseContext.Provider>
)

/* Espace apprenant : la cible du module EN COURS. Le tableau de bord, le menu
   et Ma certification suivent donc le module que l'apprenant est en train de
   suivre ; un module sans cible (ou un champ absent) donne le vous. */
export const FormeAdresseApprenant = ({ children }) => {
  const actFormation = useContext(UserContext)?.actFormation
  return <FormeAdresseProvider cible={actFormation?.cible}>{children}</FormeAdresseProvider>
}

export const useFormeAdresse = () => useContext(FormeAdresseContext)

/* `const t = useTexte()` puis `t(languageValues.dashboard.yourProgram)` : la
   langue courante, et la forme d'adresse du contexte. */
export const useTexte = () => {
  const langue = useContext(LanguageContext)?.actLanguage
  const forme = useContext(FormeAdresseContext)
  return useCallback((entree) => choisirTexte(entree, langue, forme), [langue, forme])
}

export default FormeAdresseContext
